import { bzAxios } from 'Lib/bzAxios'

interface FetchOptions {
  params?: Record<string, any>
  method?: 'get' | 'post'
}

export const fetchBMData = async <T>(
  endpoint: string,
  networkIdEnc: string,
  { params = {}, method = 'get' }: FetchOptions = {}
): Promise<T> => {
  const config = {
    params: {
      networkIdEnc,
      ...params,
    },
  }

  const response =
    method === 'post'
      ? await bzAxios.post<T>(endpoint, null, config)
      : await bzAxios.get<T>(endpoint, config)

  return response.data
}
